<template>
    <div class="modal is-active" >
        <div class="modal-background" />
        <div class="modal-card ">
            <button
                class="close is-pulled-right"
                aria-label="close"
                @click="$emit('close')"
            >
                <span class="icon is-large">
                    <i class="mdi mdi-24px mdi-close has-text-black"></i>
                </span>
            </button>
            <section class="modal-card-body is-paddingless is-scroll-hidden">
                <div class="section session-header mx-4 pb-2">
                    <nav class="level mb-0">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-4">
                                    <span class="primary-font has-text-black is-uppercase">{{$t('session_player_stats')}}</span>: <span class="primary-font has-text-eduloc-red">{{ player.alias || player.name }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-4 has-text-eduloc-blue primary-font">{{gameType}}</p>
                            </div>
                        </div>
                    </nav>
                    <div class="">
                        <p class="">
                            <span class="has-text-black secondary-font-bold">{{$t('game_date')}}:</span>&nbsp;
                            <span class="has-text-eduloc-red secondary-font-bold" 
                            v-html="$options.filters.playerPlayDate(player.timesPlayed)"></span>
                        </p>
                    </div>
                </div>
                <div class="section session-header mx-4 pt-2">
                    <div class="columns is-mobile is-marginless">
                        <div class="column is-narrow has-background-eduloc-red has-text-white mr-2 square-zone">
                            <p class="is-size-3 has-text-white has-text-centered">{{player.position}}</p>
                            <p class="has-text-white has-text-centered margin-text">{{$t('Sessions.ranking_position')}}</p>
                        </div>
                        <div class="column is-narrow has-background-eduloc-grey has-text-white mr-2 square-zone">
                            <p class="is-size-3 has-text-white has-text-centered">{{player.score}}</p>
                            <p class="has-text-white has-text-centered margin-text">{{$t('Sessions.score')}}</p>
                        </div>
                        <div class="column has-background-white">
                            <div class="columns is-mobile has-border-eduloc-grey is-vcentered">
                                <div class="column is-narrow has-text-eduloc-red px-5">
                                    <p class="is-size-3 has-text-eduloc-red has-text-centered">{{player.hitRate}}%</p>
                                    <p class="has-text-eduloc-red has-text-centered margin-text">{{$t('Sessions.question_hit_rate')}}</p>
                                </div>
                                <div class="column is-bordered-left py-0 my-2 px-5">
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_time') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.gameTime }}</span></p>
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_time_per_answer') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.meanTime }}</span></p>
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_device') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.device }}</span></p>
                                </div>
                                <div class="column is-narrow has-background-eduloc-red ml-5 mr-0 my-4">
                                    <figure class="image is-24x24 is-clickable" @click="exportToPDF">
                                        <img src="@/assets/images/pdf_file_white.png">
                                    </figure>
                                </div>
                                <div class="column is-narrow has-background-eduloc-red mx-5 my-4" >
                                    <figure class="image is-24x24 is-clickable" @click="exportCSV">
                                            <img src="@/assets/images/file-csv-white.png">
                                        </figure>
                                </div>
                                <div class="column is-narrow has-background-eduloc-red mx-5 my-4" style="display:none;">
                                    <download-csv :data="questionsData" :name="'questions_data.csv'">
                                        <figure class="image is-24x24 is-clickable" ref="btnQuestions">
                                            <img src="@/assets/images/file-csv-white.png">
                                        </figure>
                                    </download-csv>
                                    <download-csv :data="cluesData" :name="'clues_data.csv'" v-if="isTreasurehunt">
                                        <figure class="image is-24x24 is-clickable" ref="btnClues">
                                            <img src="@/assets/images/file-csv-white.png">
                                        </figure>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <section class="">
                <div class="section clue-data mx-4 pt-2" v-if="isTreasurehunt">
                    <table class="table is-fullwidth is-narrow is-vcentered clue-detail-table mb-4">
                        <thead>
                            <tr class="has-background-eduloc-grey-background has-text-black">
                                <th class="py-3 px-5">
                                    {{ $t('Sessions.clue_count') }} ({{cluesCount}})
                                </th>
                                <th class="py-3 px-5">
                                    {{ $t('Sessions.helpers_title') }}
                                </th>
                                <th class="has-text-centered py-3 px-5">
                                    {{ $t('Sessions.time_spent') }}
                                </th>
                                
                                <th class="has-text-centered py-3 px-5">
                                    {{ $t('Sessions.points_obtained') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="clue in player.clues"
                                :key="clue._id"
                                class="is-bordered-bottom"
                            >
                                <td class="is-fixed-width py-3 px-5 secondary-font">
                                    <p class="is-text-overflow">
                                    {{ clue.description | strippedContent }}</p>
                                </td>
                                <td class="py-3 px-5 is-narrow secondary-font">
                                    {{ clueAssistance(clue.scores[0]) }}
                                </td>
                                <td class="has-text-centered py-3 px-5 is-narrow secondary-font" >
                                    {{ 0 | timeSpent }}
                                </td>
                                
                                <td class="has-text-centered py-3 px-5 is-narrow">
                                    {{ getPoints(clue.scores[0]) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="section question-data mx-4 pt-2">

                    <table class="table is-fullwidth is-narrow is-vcentered question-detail-table mb-4">
                        <thead>
                            <tr class="has-background-eduloc-grey-background has-text-black">
                                <th class="py-3 px-5">
                                    {{ $t('Sessions.questions') }} ({{questionsCount}})
                                </th>
                                <th class="py-3 px-5">
                                    {{ $t('Sessions.question_type') }}
                                </th>
                                <th class="py-3 px-5">
                                    {{ $t('Sessions.user_answer') }}
                                </th>
                                <th class="has-text-centered py-3 px-5">
                                    {{ $t('Sessions.time_spent') }}
                                </th>
                                <th class="has-text-centered py-3 px-5">
                                    {{ $t('Sessions.points_obtained') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="question in player.questions"
                                :key="question._id"
                                class="is-bordered-bottom"
                            >
                                <td class="py-3 px-5 is-narrow secondary-font">
                                    <p class="is-text-overflow-small">
                                    {{ question.title | strippedContent }}
                                    </p>
                                </td>
                                <td class="py-3 px-5 is-narrow secondary-font">
                                    {{ $t('creation.answer_type.' + question.answerType) }}
                                </td>
                                <td class="py-3 px-5 secondary-font">
                                    {{ questionUserAnswer(question) }}
                                </td>
                                <td class="has-text-centered py-3 px-5 is-narrow secondary-font">
                                    {{ questionResponseTime(question.scores) }}
                                </td>
                                <td class="has-text-centered py-3 px-5 is-narrow">
                                    {{ questionObtainedPoints(question.scores) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </section>
            </section>
        </div>
        <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1100"
            :pdf-content-width="'100%'"
            :filename="player.alias ? player.alias : player.username"
            :pdf-quality="2"
            :manual-pagination="true"
            ref="html2Pdf"
            :htmlToPdfOptions="{
                margin: 20,
                jsPDF: {
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4',
                    putOnlyUsedFonts: 'false',
                    compress: 'false',
                    precision: '20',
                    filename: player.alias ? player.alias : player.username,
                },
            }"
            @hasDownloaded="showProgress($event)"
        >
            <section slot="pdf-content">
                <div class="section session-header mx-0 pb-2 px-0 pt-0">
                    <nav class="level mb-0">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-4">
                                    <span class="primary-font has-text-black is-uppercase">{{$t('session_player_stats')}}</span>: <span class="primary-font has-text-eduloc-red">{{ player.alias || player.name }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-4 has-text-eduloc-blue primary-font">{{gameType}}</p>
                            </div>
                        </div>
                    </nav>
                    <div class="">
                        <p class="">
                            <span class="has-text-black secondary-font-bold">{{$t('game_date')}}:</span>&nbsp;
                            <span class="has-text-eduloc-red secondary-font-bold" 
                            v-html="$options.filters.playerPlayDate(player.timesPlayed)"></span>
                        </p>
                    </div>
                </div>
                <div class="section session-header mx-0 px-0 pt-2">
                    <div class="columns is-mobile is-marginless">
                        <div class="column is-narrow has-background-eduloc-red has-text-white mr-2 square-zone">
                            <p class="is-size-3 has-text-white has-text-centered">{{player.position}}</p>
                            <p class="has-text-white has-text-centered margin-text">{{$t('Sessions.ranking_position')}}</p>
                        </div>
                        <div class="column is-narrow has-background-eduloc-grey has-text-white mr-2 square-zone">
                            <p class="is-size-3 has-text-white has-text-centered">{{player.score}}</p>
                            <p class="has-text-white has-text-centered margin-text">{{$t('Sessions.score')}}</p>
                        </div>
                        <div class="column has-background-white">
                            <div class="columns is-mobile has-border-eduloc-grey is-vcentered">
                                <div class="column is-narrow has-text-eduloc-red px-5">
                                    <p class="is-size-3 has-text-eduloc-red has-text-centered">{{player.hitRate}}%</p>
                                    <p class="has-text-eduloc-red has-text-centered margin-text">{{$t('Sessions.question_hit_rate')}}</p>
                                </div>
                                <div class="column is-bordered-left py-0 my-2 px-5">
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_time') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.gameTime }}</span></p>
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_time_per_answer') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.meanTime }}</span></p>
                                    <p class="has-text-black lh-1">{{ $t('Sessions.game_device') }}:&nbsp;<span class="has-text-eduloc-red">{{ player.device }}</span></p>
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
                <!--<div class="section session-header mx-4 pt-2">
                    <div class="columns is-bordered has-background-eduloc-grey-background has-text-black is-vcentered has-text-centered">
                        <div class="column is-3 is-vcentered">
                            {{ $t('Sessions.questions') }} ({{questionsCount}})
                        </div>
                        <div class="column is-2">
                            {{ $t('Sessions.question_type') }}
                        </div>
                        <div class="column is-3">
                            {{ $t('Sessions.user_answer') }}
                        </div>
                        <div class="column is-2">
                            {{ $t('Sessions.time_spent') }}
                        </div>
                        <div class="column is-2">
                            {{ $t('Sessions.points_obtained') }}
                        </div>
                    </div>
                    <div
                        v-for="question in player.questions"
                        :key="question._id"
                        class="columns"
                    >
                        <div class="column is-3">
                            {{ question.title | strippedContent }}
                        </div>
                        <div class="column is-2">
                            {{ $t('creation.answer_type.' + question.answerType) }}
                        </div>
                        <div class="column is-3">
                            {{ questionUserAnswer(question) }}
                        </div>
                        <div class="column is-2">
                            {{ questionResponseTime(question.scores) }}
                        </div>
                        <div class="column is-2">
                            {{ questionObtainedPoints(question.scores) }}
                        </div>
                    </div>
                    
                </div>-->
                <section class="px-0 py-0">
                    <div class="section clue-data mx-0 pt-2 px-0" v-if="isTreasurehunt">
                        <table class="table is-fullwidth is-narrow is-vcentered clue-detail-table mb-4">
                            <thead>
                                <tr class="has-background-eduloc-grey-background has-text-black">
                                    <th class="py-3 px-5">
                                        {{ $t('Sessions.clue_count') }} ({{cluesCount}})
                                    </th>
                                    <th class="py-3 px-5">
                                        {{ $t('Sessions.helpers_title') }}
                                    </th>
                                    <th class="has-text-centered py-3 px-5">
                                        {{ $t('Sessions.time_spent') }}
                                    </th>
                                    
                                    <th class="has-text-centered py-3 px-5">
                                        {{ $t('Sessions.points_obtained') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="clue in player.clues"
                                    :key="clue._id"
                                    class="is-bordered-bottom"
                                >
                                    <td class="is-fixed-width py-3 px-5">
                                        <p class="">
                                        {{ clue.description | strippedContent }}</p>
                                    </td>
                                    <td class="py-3 px-5 is-narrow">
                                        {{ clueAssistance(clue.scores[0]) }}
                                    </td>
                                    <td class="has-text-centered py-3 px-5 is-narrow">
                                        {{ 0 | timeSpent }}
                                    </td>
                                    
                                    <td class="has-text-centered py-3 px-5 is-narrow">
                                        {{ getPoints(clue.scores[0]) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    


                    <div class="section question-data mx-0 pt-2 px-0">

                        <table class="table is-fullwidth is-narrow is-vcentered question-detail-table mb-4" style="table-layout: fixed; width: 100%">
                            <thead>
                                <tr class="has-background-eduloc-grey-background has-text-black is-vcentered ">
                                    <th class="" style="width: 33%; max-width: 33%; padding-bottom: 1.2rem;">
                                        {{ $t('Sessions.questions') }} ({{questionsCount}})
                                    </th>
                                    <th class="" style="padding-bottom: 1.2rem; text-align:center;">
                                        {{ $t('Sessions.question_type') }}
                                    </th>
                                    <th class="" style="width: 33%; max-width: 33%; padding-bottom: 1.2rem;">
                                        {{ $t('Sessions.user_answer') }}
                                    </th>
                                    <th class="" style="padding-bottom: 1.2rem; text-align:center;">
                                        {{ $t('Sessions.time_spent') }}
                                    </th>
                                    <th class="" style="padding-bottom: 1.2rem; text-align:center;">
                                        {{ $t('Sessions.points_obtained') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="question in player.questions"
                                    :key="question._id"
                                    class="is-bordered-bottom"
                                >
                                    <td class="" style="word-wrap: break-word; width: 33%; max-width: 33%; padding-bottom: 1.2rem;">
                                        
                                        {{ question.title | strippedContent }}
                                    
                                    </td>
                                    <td class="is-narrow">
                                        {{ $t('creation.answer_type.' + question.answerType) }}
                                    </td>
                                    <td class="" style="width: 33%; max-width: 33%; padding-bottom: 1.2rem;">
                                        {{ questionUserAnswer(question) }}
                                    </td>
                                    <td class="is-narrow">
                                        {{ questionResponseTime(question.scores) }}
                                    </td>
                                    <td class="is-narrow" style="text-align: center; padding-bottom: 1.2rem;">
                                        {{ questionObtainedPoints(question.scores) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </section>
        </VueHtml2pdf>
        
    </div>
</template>

<script>

import _ from 'underscore';
import { timeFormat } from '@/lib/helpers';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';
//import JsonCSV from 'vue-json-csv'

export default {
    name: 'SessionDetailPlayer',
    components: {
        VueHtml2pdf,
        //JsonCSV,
    },
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
        reportInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
        questionsCount: {
            type: Number
        },
        cluesCount: {
            type: Number
        }
    },
    data() {
        return {
            showingProgress: false,
            questionsData: [],
            cluesData: [],
        };
    },
    created() {
        //window.addEventListener('resize', this.onResize);
    },
    mounted() {
        // console.log(this.player)
        /*this.$refs['inner-content'].style.maxHeight =
            this.$refs.modal.$el.clientHeight - 100 + 'px';*/
        if (this.player.questions) {
            this.makePlayerQuestionsData();
        }
        if (this.player.clues) { 
            this.makePlayerCluesData();
        }
        
    },
    destroyed() {
        //window.removeEventListener('resize', this.onResize);
    },
    filters: {
        timeSpent(time) {
            return timeFormat(+time) + ' min';
        },
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
        playerPlayDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        getFilename() {
            return this.player.alias ? this.player.alias : this.player.username;
        },
        hasPlayed(){
            return this.player.time != '0';
        },
        gameType(){

            if(this.reportInfo.projectFormat){
                return this.$t(`Constants.${this.reportInfo.projectFormat}`);
            }else if(this.reportInfo.gameType && this.reportInfo.mode=='map'){
                return this.$t('Constants.PROJECT_TYPE_GEOQUIZ');
            }
            return this.$t('Constants.PROJECT_TYPE_QUIZ');
        },
        isTreasurehunt() {
            // console.log(this.reportInfo.projectFormat)
            if (this.reportInfo.projectFormat) {
                return this.reportInfo.projectFormat=='PROJECT_TYPE_TREASUREHUNT';
            }
            return this.reportInfo.gameType=='treasurehunt'
        },
        answeredRight() {
            let correctAnswers = 0;
            for (let question of this.player.questions) {
                if (
                    _.filter(question.scores, (score) => {
                        if (score.profile) {
                            return (
                                score.points > 0 &&
                                score.profile == this.player._id
                            );
                        } else {
                            return (
                                score.points > 0 &&
                                score.owner._id == this.player._id
                            );
                        }
                    }).length
                ) {
                    correctAnswers++;
                }
            }
            return correctAnswers;
        },
    },
    methods: {
        getPoints(clueData){
            if(clueData && clueData.points){
                return clueData.points;
            }
            return 0;
        },
        clueAssistance(clueData) {
            // console.log("assistance clue data",clueData)
            if(clueData){
                if (!clueData.assistance) {
                    return this.$t('Sessions.helpers.nothing');
                } else {
                    // console.log("assistance recived",clueData.assistance)
                    if (
                        clueData.assistance.compass &&
                        clueData.assistance.distance
                    ) {
                        return this.$t('Sessions.helperswith_compass_and_distance');
                    } else if (clueData.assistance.compass) {
                        return this.$t('Sessions.helperswith_compass');
                    } else if (clueData.assistance.distance) {
                        return this.$t('Sessions.helperswith_distance');
                    } else {
                        return this.$t('Sessions.helpers.nothing');
                    }
                }
            }else{
                return this.$t('Sessions.helpers.nothing');
            }
        },
        questionResponseTime(scores) {
            let scoreData = _.filter(scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });
            if (scoreData.length) {
                return this.$options.filters.timeSpent(scoreData[0].time);
            }
        },
        questionObtainedPoints(scores) {
            let scoreData = _.filter(scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });
            if (scoreData.length) {
                return scoreData[0].points;
            }
        },
        questionUserAnswer(question) {
            let scoreData = _.filter(question.scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });

            if (scoreData.length) {
                if (
                    question.answerType == 'SINGLE' ||
                    question.answerType == 'FREETEXT'
                ) {
                    if (typeof scoreData[0].answer.value != 'string') {
                        return scoreData[0].answer.value[0].value;
                    } else {
                        return scoreData[0].answer.value;
                    }
                } else if (question.answerType == 'HANGMAN') {
                    let hangmanValue = [];
                    scoreData[0].answer.value.forEach(element => {
                        hangmanValue.push(element.value)    
                    });
                    //console.log(scoreData[0].answer.value)
                    return hangmanValue.join();
                } else if (question.answerType == 'MULTIPLE') {
                    let userAnswer = [];
                    for (let answer of scoreData[0].answer.value) {
                        userAnswer.push(answer.value);
                    }
                    return userAnswer.join();
                }
            }
        },

        exportCSV() {
            if (this.$refs.btnQuestions) {
                this.$refs.btnQuestions.click();
            }
            if (this.$refs.btnClues) {
                //setTimeout(() => {
                    this.$refs.btnClues.click();
                //}, 500);
            }
        },

        makePlayerQuestionsData() {
            let elements = [];
            const titleLabel = this.$t('Sessions.questions');
            const typeLabel = this.$t('Sessions.question_type');
            const answerLabel = this.$t('Sessions.user_answer');
            const timeLabel = this.$t('Sessions.time_spent');
            const points = this.$t('Sessions.points_obtained');

            const single = this.$t('creation.answer_type.SINGLE');
            const multiple = this.$t('creation.answer_type.MULTIPLE');
            const hangman = this.$t('creation.answer_type.HANGMAN');
            const freetext = this.$t('creation.answer_type.FREETEXT');

            const playerData = this.player
            
            this.player.questions.forEach(function (question) { 
                
                const div = document.createElement('div');
                div.innerHTML = question.title;
                const text = div.textContent || div.innerText || '';
                let element = [];

                //element[titleLabel] = text;

                let answer_type;
                switch (question.answerType) {
                    case "SINGLE":
                        answer_type = single;
                        break;
                    case "MULTIPLE":
                        answer_type = multiple;
                        break;
                    case "HANGMAN":
                        answer_type = hangman;
                        break;
                    case "FREETEXT":
                        answer_type = freetext;
                        break;
                }

                let answerValue;

                let scoreData = _.filter(question.scores, (score) => {
                    if (score.profile) {
                        return score.profile == playerData._id;
                    } else {
                        return score.owner._id == playerData._id;
                    }
                });

                if (scoreData.length) {
                    if (
                        question.answerType == 'SINGLE' ||
                        question.answerType == 'FREETEXT'
                    ) {
                        if (typeof scoreData[0].answer.value != 'string') {
                            answerValue =  scoreData[0].answer.value[0].value;
                        } else {
                            answerValue =  scoreData[0].answer.value;
                        }
                    } else if (question.answerType == 'HANGMAN') {
                        let hangmanValue = [];
                        scoreData[0].answer.value.forEach(element => {
                            hangmanValue.push(element.value)    
                        });
                        //console.log(scoreData[0].answer.value)
                        answerValue =  hangmanValue.join();
                    } else if (question.answerType == 'MULTIPLE') {
                        let userAnswer = [];
                        for (let answer of scoreData[0].answer.value) {
                            userAnswer.push(answer.value);
                        }
                        answerValue =  userAnswer.join();
                    }

                    elements.push({
                        title: text,
                        answer_type,
                        time: timeFormat(+scoreData[0].time) + ' min',
                        user_answer: answerValue,
                        score: scoreData[0].points,
                    });
                }

                
                // console.log(element)

                
                
            });
            // console.log(elements)
            this.questionsData = elements;
        },
        makePlayerCluesData() {
            let elements = [];
            const titleLabel = this.$t('Sessions.questions');
            const typeLabel = this.$t('Sessions.question_type');
            const answerLabel = this.$t('Sessions.user_answer');
            const timeLabel = this.$t('Sessions.time_spent');
            const points = this.$t('Sessions.points_obtained');

            const single = this.$t('creation.answer_type.SINGLE');
            const multiple = this.$t('creation.answer_type.MULTIPLE');
            const hangman = this.$t('creation.answer_type.HANGMAN');
            const freetext = this.$t('creation.answer_type.FREETEXT');

            const as_nothing = this.$t('Sessions.helpers.nothing');
            const as_all = this.$t('Sessions.helperswith_compass_and_distance');
            const as_compass = this.$t('Sessions.helperswith_compass');
            const as_distance = this.$t('Sessions.helperswith_distance');

            const playerData = this.player
            
            this.player.clues.forEach(function (clue) { 
                
                const div = document.createElement('div');
                div.innerHTML = clue.description;
                const text = div.textContent || div.innerText || '';
                let element = [];



                let assistance;
                if (!clue.assistance) {
                    assistance = as_nothing;  //this.$t('Sessions.helpers.nothing');
                } else {
                    // console.log("assistance recived",clueData.assistance)
                    if (
                        clueData.assistance.compass &&
                        clueData.assistance.distance
                    ) {
                        assistance = as_all; 
                    } else if (clueData.assistance.compass) {
                        assistance = as_compass; 
                    } else if (clueData.assistance.distance) {
                        assistance = as_distance;  
                    } else {
                        assistance = as_nothing; 
                    }
                }

                let scoreData = _.filter(clue.scores, (score) => {
                    if (score.profile) {
                        return score.profile == playerData._id;
                    } else {
                        return score.owner._id == playerData._id;
                    }
                });

                if (scoreData.length) {

                    elements.push({
                        title: text,
                        assistance,
                        time: timeFormat(+scoreData[0].time) + ' min',
                        score: scoreData[0].points,
                    });
                }

                
                // console.log(element)

                
                
            });
            // console.log(elements)
            this.cluesData = elements;
        },
        


        onResize(e) {
            this.$refs['inner-content'].style.maxHeight =
                this.$refs.modal.$el.clientHeight - 100 + 'px';
        },
        exportToPDF() {
            this.showingProgress = true;
            this.$refs.html2Pdf.generatePdf();
        },
        showProgress(e) {
            this.showingProgress = false;
        },
    },
};
</script>

<style scoped>
.margin-text{
    margin-top: -0.5rem;
}
.square-zone{
    min-width: 6rem;
}
.modal-card-body{
    background-color: var(--eduloc-grey-very-light)
}
.has-border-eduloc-grey{
    border: 1px solid var(--eduloc-grey-light)
}
.is-bordered-left{
    border-left: 7px solid var(--eduloc-red);
}
.lh-1{
    line-height: 1.2rem;
}
.close{
    height: 20px;
    position: absolute;
    vertical-align: top;
    width: 20px;
    right: 25px;
    top: 5px;
}
.is-text-overflow {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 40rem;
}
.is-text-overflow-small {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 10rem;
}
.table th{
    font-weight: normal;
}
.game-data{
    max-height: calc(100vh - 270px);
}







.content table td {
    border: none;
}

.content .table.is-vcentered td {
    vertical-align: middle;
}

.clue-detail-table th ,.question-detail-table th{
    border: 1px solid var(--eduloc-grey-background);
}

.modal-card {
    width: 70%;
}



#pdf /deep/.bubble-container .title {
    color: #ffffff;
    padding-bottom: 1.5rem;
}

#pdf .general-data,
#pdf .general-data tr,
#pdf .general-data td {
    border: 1px solid white;
}

#pdf .clue-table,
#pdf .clue-table tbody tr,
#pdf .clue-table tbody td {
    border: 1px solid white;
}

#pdf .helpers-table,
#pdf .helpers-table tbody tr,
#pdf .helpers-table tbody td {
    border: 1px solid white;
}

#pdf .question-table,
#pdf .question-table tbody,
#pdf .question-table thead,
#pdf .question-table tr,
#pdf .question-table td {
    border: 1px solid white;
}
.button.is-fullsize {
    width: 100%;
}

</style>
